module.exports = __webpack_public_path__ + "static/3-1d9ae569b2c6e939b02e15e45ccd1830.jpeg";